import styled from "@emotion/styled";
import { capitalize } from "lodash-es";
import React, { useState } from "react";
import { GlobalStore } from "store/global/GlobalStore";
import { getApiEnv } from "../../../../config/env";

export const VersionLabel: React.FC = () => {
  const [isPartiallyVisible, setIsPartiallyVisible] = useState(false);
  const quote = GlobalStore.useState(s => s.quote);

  return (
    <VersionLabelContainer
      onClick={() => setIsPartiallyVisible(s => !s)}
      isPartiallyVisible={isPartiallyVisible}
    >
      {capitalize(getApiEnv())} API | v.{APP_VERSION} {quote?.routeType} {quote?.solver}
    </VersionLabelContainer>
  );
};

// Sub components

const VersionLabelContainer = styled.div<{ isPartiallyVisible: boolean }>`
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 999999;
  background-color: ${props => (props.isPartiallyVisible ? "transparent" : "red")};
  color: ${props => (props.isPartiallyVisible ? "transparent" : "white")};
  padding: 0.5rem;
  cursor: pointer;
  border: 1px ${props => (props.isPartiallyVisible ? "none" : "solid")} red;
`;
